module.exports = __webpack_public_path__ + "static/media/card-error.00400163.svg";